<mat-form-field
  [class]="selectClass()"
  appearance="outline"
>
  <mat-select
    (valueChange)="valueChanged($event)"
    [placeholder]="showPhoneCode() ? 'Code' : 'Country'"
    [value]="value()"
    panelClass="single-select-overlay country-select-overlay"
  >
    <mat-select-trigger>
      {{ selectedCountry().name }}{{ showPhoneCode() ? ' (' + selectedCountry().phoneCode + ')' : '' }}
    </mat-select-trigger>

    <div class="sticky top-0 z-10 bg-white w-full pt-2 pb-1 px-3">
      <app-search-input
        (searchDataEvent)="searchValue.set($event)"
        [clearOnBlur]="true"
        [inputValue]="searchValue()"
        inputWidth="100%"
        placeholder="Search country"
      />
    </div>

    @for (country of filteredCollection(); track country.code) {
      <mat-option [value]="country.code">
        {{ country.name }}{{ showPhoneCode() ? ' (' + country.phoneCode + ')' : '' }}
      </mat-option>
    }
  </mat-select>
  <mat-icon
    class="arrow-down"
    fontIcon="keyboard_arrow_down"
    matSuffix
  />
  @if (hasError()) {
    <mat-error>Input is not valid</mat-error>
  }
</mat-form-field>
